import { render, staticRenderFns } from "./ScreenBillOfLadingExtraItemTypeForm.vue?vue&type=template&id=ce725df4&"
import script from "./ScreenBillOfLadingExtraItemTypeForm.vue?vue&type=script&lang=js&"
export * from "./ScreenBillOfLadingExtraItemTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
